import { render, staticRenderFns } from "./ShowProtocol.vue?vue&type=template&id=a9607e5e&scoped=true&"
import script from "./ShowProtocol.vue?vue&type=script&lang=js&"
export * from "./ShowProtocol.vue?vue&type=script&lang=js&"
import style0 from "./ShowProtocol.vue?vue&type=style&index=0&id=a9607e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9607e5e",
  null
  
)

export default component.exports